// Sketchbook implementation with Turn.js
document.addEventListener('DOMContentLoaded', function() {
  // Only proceed if we're on the home page
  if (!document.body.classList.contains('home')) return;

  // Create sketchbook overlay
  const overlay = document.createElement('div');
  overlay.id = 'sketchbook-overlay';
  overlay.className = 'sketchbook-overlay';
  
  // Create sketchbook container
  const sketchbook = document.createElement('div');
  sketchbook.id = 'sketchbook';
  sketchbook.className = 'sketchbook';
  
  // Get asset URLs for the images
  const coverImage = document.getElementById('sketchbook-data')?.getAttribute('data-cover-url') || '';
  const page1Image = document.getElementById('sketchbook-data')?.getAttribute('data-page1-url') || '';
  const page2Image = document.getElementById('sketchbook-data')?.getAttribute('data-page2-url') || '';
  const page3Image = document.getElementById('sketchbook-data')?.getAttribute('data-page3-url') || '';
  const page4Image = document.getElementById('sketchbook-data')?.getAttribute('data-page4-url') || '';
  const page5Image = document.getElementById('sketchbook-data')?.getAttribute('data-page5-url') || '';
  const page6Image = document.getElementById('sketchbook-data')?.getAttribute('data-page6-url') || '';
  const page7Image = document.getElementById('sketchbook-data')?.getAttribute('data-page7-url') || '';
  const page8Image = document.getElementById('sketchbook-data')?.getAttribute('data-page8-url') || '';
  const page9Image = document.getElementById('sketchbook-data')?.getAttribute('data-page9-url') || '';
  const page10Image = document.getElementById('sketchbook-data')?.getAttribute('data-page10-url') || '';
  const page11Image = document.getElementById('sketchbook-data')?.getAttribute('data-page11-url') || '';
  const page12Image = document.getElementById('sketchbook-data')?.getAttribute('data-page12-url') || '';
  const page13Image = document.getElementById('sketchbook-data')?.getAttribute('data-page13-url') || '';
  const page14Image = document.getElementById('sketchbook-data')?.getAttribute('data-page14-url') || '';
  const page15Image = document.getElementById('sketchbook-data')?.getAttribute('data-page15-url') || '';
  const page16Image = document.getElementById('sketchbook-data')?.getAttribute('data-page16-url') || '';
  const page17Image = document.getElementById('sketchbook-data')?.getAttribute('data-page17-url') || '';
  const page18Image = document.getElementById('sketchbook-data')?.getAttribute('data-page18-url') || '';
  const page19Image = document.getElementById('sketchbook-data')?.getAttribute('data-page19-url') || '';
  const page20Image = document.getElementById('sketchbook-data')?.getAttribute('data-page20-url') || '';
  const page21Image = document.getElementById('sketchbook-data')?.getAttribute('data-page21-url') || '';
  const page22Image = document.getElementById('sketchbook-data')?.getAttribute('data-page22-url') || '';
  const page23Image = document.getElementById('sketchbook-data')?.getAttribute('data-page23-url') || '';
  const page24Image = document.getElementById('sketchbook-data')?.getAttribute('data-page24-url') || '';
  const page25Image = document.getElementById('sketchbook-data')?.getAttribute('data-page25-url') || '';
  const page26Image = document.getElementById('sketchbook-data')?.getAttribute('data-page26-url') || '';
  const page27Image = document.getElementById('sketchbook-data')?.getAttribute('data-page27-url') || '';
  const page28Image = document.getElementById('sketchbook-data')?.getAttribute('data-page28-url') || '';
  const page29Image = document.getElementById('sketchbook-data')?.getAttribute('data-page29-url') || '';
  const page30Image = document.getElementById('sketchbook-data')?.getAttribute('data-page30-url') || '';
  const page31Image = document.getElementById('sketchbook-data')?.getAttribute('data-page31-url') || '';
  const page32Image = document.getElementById('sketchbook-data')?.getAttribute('data-page32-url') || '';
  const page33Image = document.getElementById('sketchbook-data')?.getAttribute('data-page33-url') || '';
  
  // Create pages
  const pages = [
    { class: 'cover-front', content: `<div class="cover-content"><img src="${coverImage}" alt="Sketchbook Cover" draggable="false"></div>` },
    { class: '', content: `<img src="${page1Image}" alt="Page 1" draggable="false">` },
    { class: '', content: `<img src="${page2Image}" alt="Page 2" draggable="false">` },
    { class: '', content: `<img src="${page3Image}" alt="Page 3" draggable="false">` },
    { class: '', content: `<img src="${page4Image}" alt="Page 4" draggable="false">` },
    { class: '', content: `<img src="${page5Image}" alt="Page 5" draggable="false">` },
    { class: '', content: `<img src="${page6Image}" alt="Page 6" draggable="false">` },
    { class: '', content: `<img src="${page7Image}" alt="Page 7" draggable="false">` },
    { class: '', content: `<img src="${page8Image}" alt="Page 8" draggable="false">` },
    { class: '', content: `<img src="${page9Image}" alt="Page 9" draggable="false">` },
    { class: '', content: `<img src="${page10Image}" alt="Page 10" draggable="false">` },
    { class: '', content: `<img src="${page11Image}" alt="Page 11" draggable="false">` },
    { class: '', content: `<img src="${page12Image}" alt="Page 12" draggable="false">` },    
    { class: '', content: `<img src="${page13Image}" alt="Page 13" draggable="false">` },    
    { class: '', content: `<img src="${page14Image}" alt="Page 14" draggable="false">` },    
    { class: '', content: `<img src="${page15Image}" alt="Page 15" draggable="false">` },    
    { class: '', content: `<img src="${page16Image}" alt="Page 16" draggable="false">` },    
    { class: '', content: `<img src="${page17Image}" alt="Page 17" draggable="false">` },    
    { class: '', content: `<img src="${page18Image}" alt="Page 18" draggable="false">` },    
    { class: '', content: `<img src="${page19Image}" alt="Page 19" draggable="false">` },    
    { class: '', content: `<img src="${page20Image}" alt="Page 20" draggable="false">` },
    { class: '', content: `<img src="${page21Image}" alt="Page 21" draggable="false">` },    
    { class: '', content: `<img src="${page22Image}" alt="Page 22" draggable="false">` },    
    { class: '', content: `<img src="${page23Image}" alt="Page 23" draggable="false">` },    
    { class: '', content: `<img src="${page24Image}" alt="Page 24" draggable="false">` },    
    { class: '', content: `<img src="${page25Image}" alt="Page 25" draggable="false">` },    
    { class: '', content: `<img src="${page26Image}" alt="Page 26" draggable="false">` },    
    { class: '', content: `<img src="${page27Image}" alt="Page 27" draggable="false">` },    
    { class: '', content: `<img src="${page28Image}" alt="Page 28" draggable="false">` },    
    { class: '', content: `<img src="${page29Image}" alt="Page 29" draggable="false">` },    
    { class: '', content: `<img src="${page30Image}" alt="Page 30" draggable="false">` },    
    { class: '', content: `<img src="${page31Image}" alt="Page 31" draggable="false">` },    
    { class: '', content: `<img src="${page32Image}" alt="Page 32" draggable="false">` },    
    { class: 'cover-back', content: `<img src="${page33Image}" alt="Page 33" draggable="false">` }
  ];
  
  // Populate sketchbook with pages
  pages.forEach((page, index) => {
    const pageElement = document.createElement('div');
    pageElement.className = page.class;
    pageElement.innerHTML = page.content;
    sketchbook.appendChild(pageElement);
  });
  
  // Add sketchbook to overlay
  overlay.appendChild(sketchbook);
  
  // Add overlay to body
  document.body.appendChild(overlay);


  // SLIDER TWO!
  // Create sketchbook overlay
  const sbt_overlay = document.createElement('div');
  sbt_overlay.id = 'sketchbook-overlay-two';
  sbt_overlay.className = 'sketchbook-overlay sketchbook-overlay-two';
  
  // Create sketchbook container
  const sbt_sketchbook = document.createElement('div');
  sbt_sketchbook.id = 'sketchbook-two';
  sbt_sketchbook.className = 'sketchbook sketchbook-two';
  
  // Get asset URLs for the images
  const sbt_coverImage = document.getElementById('sketchbook-data-two')?.getAttribute('data-cover-url') || '';
  const sbt_page1Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page1-url') || '';
  const sbt_page2Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page2-url') || '';
  const sbt_page3Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page3-url') || '';
  const sbt_page4Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page4-url') || '';
  const sbt_page5Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page5-url') || '';
  const sbt_page6Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page6-url') || '';
  const sbt_page7Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page7-url') || '';
  const sbt_page8Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page8-url') || '';
  const sbt_page9Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page9-url') || '';
  const sbt_page10Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page10-url') || '';
  const sbt_page11Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page11-url') || '';
  const sbt_page12Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page12-url') || '';
  const sbt_page13Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page13-url') || '';
  const sbt_page14Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page14-url') || '';
  const sbt_page15Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page15-url') || '';
  const sbt_page16Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page16-url') || '';
  const sbt_page17Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page17-url') || '';
  const sbt_page18Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page18-url') || '';
  const sbt_page19Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page19-url') || '';
  const sbt_page20Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page20-url') || '';
  const sbt_page21Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page21-url') || '';
  const sbt_page22Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page22-url') || '';
  const sbt_page23Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page23-url') || '';
  const sbt_page24Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page24-url') || '';
  const sbt_page25Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page25-url') || '';
  const sbt_page26Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page26-url') || '';
  const sbt_page27Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page27-url') || '';
  const sbt_page28Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page28-url') || '';
  const sbt_page29Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page29-url') || '';
  const sbt_page30Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page30-url') || '';
  const sbt_page31Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page31-url') || '';
  const sbt_page32Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page32-url') || '';
  const sbt_page33Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page33-url') || '';
  const sbt_page34Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page34-url') || '';
  const sbt_page35Image = document.getElementById('sketchbook-data-two')?.getAttribute('data-page35-url') || '';
  
  // Create pages
  const sbt_pages = [
    { class: 'cover-front', content: `<div class="cover-content"><img src="${sbt_coverImage}" alt="Sketchbook Cover" draggable="false"></div>` },
    { class: '', content: `<img src="${sbt_page1Image}" alt="Page 1" draggable="false">` },
    { class: '', content: `<img src="${sbt_page2Image}" alt="Page 2" draggable="false">` },
    { class: '', content: `<img src="${sbt_page3Image}" alt="Page 3" draggable="false">` },
    { class: '', content: `<img src="${sbt_page4Image}" alt="Page 4" draggable="false">` },
    { class: '', content: `<img src="${sbt_page5Image}" alt="Page 5" draggable="false">` },
    { class: '', content: `<img src="${sbt_page6Image}" alt="Page 6" draggable="false">` },
    { class: '', content: `<img src="${sbt_page7Image}" alt="Page 7" draggable="false">` },
    { class: '', content: `<img src="${sbt_page8Image}" alt="Page 8" draggable="false">` },
    { class: '', content: `<img src="${sbt_page9Image}" alt="Page 9" draggable="false">` },
    { class: '', content: `<img src="${sbt_page10Image}" alt="Page 10" draggable="false">` },
    { class: '', content: `<img src="${sbt_page11Image}" alt="Page 11" draggable="false">` },
    { class: '', content: `<img src="${sbt_page12Image}" alt="Page 12" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page13Image}" alt="Page 13" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page14Image}" alt="Page 14" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page15Image}" alt="Page 15" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page16Image}" alt="Page 16" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page17Image}" alt="Page 17" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page18Image}" alt="Page 18" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page19Image}" alt="Page 19" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page20Image}" alt="Page 20" draggable="false">` },
    { class: '', content: `<img src="${sbt_page21Image}" alt="Page 21" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page22Image}" alt="Page 22" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page23Image}" alt="Page 23" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page24Image}" alt="Page 24" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page25Image}" alt="Page 25" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page26Image}" alt="Page 26" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page27Image}" alt="Page 27" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page28Image}" alt="Page 28" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page29Image}" alt="Page 29" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page30Image}" alt="Page 30" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page31Image}" alt="Page 31" draggable="false">` },    
    { class: '', content: `<img src="${sbt_page32Image}" alt="Page 32" draggable="false">` },
    { class: '', content: `<img src="${sbt_page33Image}" alt="Page 33" draggable="false">` },
    { class: '', content: `<img src="${sbt_page34Image}" alt="Page 34" draggable="false">` },    
    { class: 'cover-back', content: `<img src="${sbt_page35Image}" alt="Page 35" draggable="false">` }
  ];
  
  // Populate sketchbook with pages
  sbt_pages.forEach((page, index) => {
    const pageElement = document.createElement('div');
    pageElement.className = page.class;
    pageElement.innerHTML = page.content;
    sbt_sketchbook.appendChild(pageElement);
  });
  
  // Add sketchbook to overlay
  sbt_overlay.appendChild(sbt_sketchbook);
  
  // Add overlay to body
  document.body.appendChild(sbt_overlay);



  
  // Initialize turn.js
  function initTurnJS() {
    $('.sketchbook').click(function() {
      if (!$(this).parents('.sketchbook-overlay').hasClass('dismissed')) {
        if ($(this).hasClass('sketchbook-two')) {
          $(sbt_sketchbook).turn('page', 1);
        } else {
          $(sketchbook).turn('page', 1);
        }
        
      }
      $(this).parents('.sketchbook-overlay').toggleClass('dismissed');
    });

    if (!Modernizr.touchevents) {
      $('.sketchbook-overlay').hover(function() {
        $(this).addClass('lift-up');
      }, function() {
        $(this).removeClass('lift-up');
      });
    }

    $(sketchbook).turn({
      width: 450,
      height: 400,
      display: 'single',
      autoCenter: true,
      gradients: true,
      acceleration: true,
      turnCorners: true,
      elevation: 50,
      duration: 500,  // Slower page turn for better control
      cornerSize: 100, // Larger corner size for easier turning
      when: {
        turning: function(e, page, view) {
          // Prevent default browser behavior when turning
          e.preventDefault();
          console.log(page);
          console.log(view);

          if (page == 0 || page == 1 || page == 34) {
            $(this).turn('display', 'single');
          } else {
            $(this).turn('display', 'double');
          }
          
          
        },
        turned: function(e, page) {
          // Do something when a page is turned
          console.log('Turned to page:', page);
        }
      }
    });
    
    // Prevent default drag behavior on the sketchbook
    sketchbook.addEventListener('dragstart', (e) => e.preventDefault());
    
    // Apply pointer-events to make pages turnable but not images draggable
    document.querySelectorAll('#sketchbook > div').forEach(page => {
      page.addEventListener('mousedown', (e) => {
        // Only prevent default if we're on an image
        if (e.target.tagName === 'IMG') {
          e.preventDefault();
        }
      });
    });
    
    // Fade in the overlay
    setTimeout(() => {
      overlay.classList.add('visible');
      overlay.classList.add('dismissed');
      // $(overlay).fadeIn(750);
    }, 500);
    
    // Automatically turn to pages 1 & 2 after a delay
    setTimeout(() => {
      // $(sketchbook).turn('next');
    }, 2000);
    
    // Add click zones for easier page turning
    const leftClickZone = document.createElement('div');
    leftClickZone.className = 'page-turn-zone left';
    leftClickZone.addEventListener('click', () => {
      $(sketchbook).turn('previous');
    });
    
    const rightClickZone = document.createElement('div');
    rightClickZone.className = 'page-turn-zone right';
    rightClickZone.addEventListener('click', () => {
      $(sketchbook).turn('next');
    });
    
    overlay.appendChild(leftClickZone);
    overlay.appendChild(rightClickZone);

    $(sbt_sketchbook).turn({
      width: 450,
      height: 400,
      display: 'single',
      autoCenter: true,
      gradients: true,
      acceleration: true,
      turnCorners: false,
      elevation: 50,
      duration: 500,  // Slower page turn for better control
      cornerSize: 100, // Larger corner size for easier turning
      when: {
        turning: function(e, page, view) {
          // Prevent default browser behavior when turning
          e.preventDefault();
          console.log(page);
          console.log(view);
  
          if (page == 0 || page == 1 || page == 36) {
            $(this).turn('display', 'single');
          } else {
            $(this).turn('display', 'double');
          }
          
          
        },
        turned: function(e, page) {
          // Do something when a page is turned
          console.log('Turned to page:', page);
        }
      }
    });
    
    // Prevent default drag behavior on the sbt_sketchbook
    sbt_sketchbook.addEventListener('dragstart', (e) => e.preventDefault());
    
    // Apply pointer-events to make pages turnable but not images draggable
    document.querySelectorAll('#sketchbook-two > div').forEach(page => {
      page.addEventListener('mousedown', (e) => {
        // Only prevent default if we're on an image
        if (e.target.tagName === 'IMG') {
          e.preventDefault();
        }
      });
    });
    
    // Fade in the overlay
    setTimeout(() => {
      sbt_overlay.classList.add('visible');
      sbt_overlay.classList.add('dismissed');
      // $(sbt_overlay).fadeIn(750);
    }, 500);
    
    // Automatically turn to pages 1 & 2 after a delay
    setTimeout(() => {
      // $(sketchbook).turn('next');
    }, 2000);
    
    // Add click zones for easier page turning
    const sbt_leftClickZone = document.createElement('div');
    sbt_leftClickZone.className = 'page-turn-zone left';
    sbt_leftClickZone.addEventListener('click', () => {
      $(sbt_sketchbook).turn('previous');
    });
    
    const sbt_rightClickZone = document.createElement('div');
    sbt_rightClickZone.className = 'page-turn-zone right';
    sbt_rightClickZone.addEventListener('click', () => {
      $(sbt_sketchbook).turn('next');
    });
    
    sbt_overlay.appendChild(sbt_leftClickZone);
    sbt_overlay.appendChild(sbt_rightClickZone);

  }
  
  // Close button functionality
  const closeButton = document.createElement('button');
  closeButton.id = 'close-sketchbook';
  closeButton.className = 'close-sketchbook';
  closeButton.innerHTML = '×';
  closeButton.addEventListener('click', function() {
    // overlay.classList.remove('visible');
    // setTimeout(() => {
    //   overlay.remove();
    // }, 500);
    overlay.classList.add('dismissed');
    $(sketchbook).turn('page', 1);
    
  });
  
  overlay.appendChild(closeButton);


  // Close button functionality
  const sbt_closeButton = document.createElement('button');
  sbt_closeButton.id = 'close-sketchbook-two';
  sbt_closeButton.className = 'close-sketchbook';
  sbt_closeButton.innerHTML = '×';
  sbt_closeButton.addEventListener('click', function() {
    // sbt_overlay.classList.remove('visible');
    // setTimeout(() => {
    //   sbt_overlay.remove();
    // }, 500);
    sbt_overlay.classList.add('dismissed');
    $(sbt_sketchbook).turn('page', 1);
    
  });

  sbt_overlay.appendChild(sbt_closeButton);
  
  // Check if jQuery is already loaded
  if (window.jQuery) {
    // Load turn.js script
    const turnScript = document.createElement('script');
    turnScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/turn.js/3/turn.min.js';
    turnScript.onload = initTurnJS;
    document.head.appendChild(turnScript);
  } else {
    // Load jQuery first, then turn.js
    const jQueryScript = document.createElement('script');
    jQueryScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js';
    jQueryScript.onload = function() {
      const turnScript = document.createElement('script');
      turnScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/turn.js/3/turn.min.js';
      turnScript.onload = initTurnJS;
      document.head.appendChild(turnScript);
    };
    document.head.appendChild(jQueryScript);
  }
});
